exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".referral-page {\n  min-height: 100%;\n  background-color: #f2f2f2;\n  padding-left: 43px;\n  padding-right: 113px;\n  padding-top: 23px;\n  margin-left: 200px; }\n  .referral-page .ant-table-selection-column {\n    width: 100px; }\n", ""]);

